import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  retrieveVehicleBrands,
  retrieveVehicleModels,
  updateDriverVehicle,
  deleteDriverVehicle,
} from "../../actions/commonActions";
import "./vehiclesList.css"
export default function VehiclesList({ vehicles }) {

  console.log("Vehicles Check:", vehicles)
  return (
    (vehicles && (
      <table className="table table-striped">
        {/* <thead>
          <tr>
            <th>Brand</th>
            <th>Model</th>
            <th>Plate #</th>
            <th>Actions</th>
          </tr>
        </thead> */}
        <tbody>
          {vehicles &&
            vehicles.map((v) => {
              return <Vehicle vehicle={v} />;
            })}
        </tbody>
      </table>
    )) || <p>You don't have any vehicles registered at the moment.</p>
  );
}

function Vehicle({ vehicle }) {
  const dispatch = useDispatch();

  const { vehicleBrands, vehicleModels } = useSelector(
    (reduxState) => reduxState.common
  );
  const {
    vehicle_brand_id,
    vehicle_model_id,
    license_plate,
    driver_vehicle_id,
    driver_id,
    vehicle_charger_type_id,
    year,
  } = vehicle;
  const [licensePlate, setLicensePlate] = useState(license_plate);
  const [vehicleBrand, setVehicleBrand] = useState(vehicle_brand_id);
  const [vehicleModel, setVehicleModel] = useState(vehicle_model_id);
  const [editing, setEditing] = useState(false);

  const updateVehicle = () => {
    updateDriverVehicle(
      dispatch,
      driver_id,
      driver_vehicle_id,
      {
        license_plate: licensePlate,
        vehicle_brand_id: vehicleBrand,
        vehicle_model_id: vehicleModel,
        vehicle_charger_type_id,
        year,
      },
      () => {
        setEditing(false);
      }
    );
  };

  const deleteVehicle = (driver_vehicle_id) => {
    deleteDriverVehicle(dispatch, driver_id, driver_vehicle_id);
  };

  useEffect(() => {
    if (vehicleBrands.length == 0) {
      retrieveVehicleBrands(dispatch);
    }
  }, [vehicleBrands]);

  useEffect(() => {
    if (vehicleModels.length == 0) {
      retrieveVehicleModels(dispatch, vehicleBrand);
    }
  }, [vehicleModels]);

  useEffect(() => {
    if (vehicleBrand !== "") retrieveVehicleModels(dispatch, vehicleBrand);
  }, [vehicleBrand]);

  return (
    (editing && (
      <tr>
        <td>
          <select
            className="form-control my-2"
            id="vehicleBrand"
            name="vehicleBrand"
            value={vehicleBrand}
            onChange={(e) => setVehicleBrand(e.target.value)}
          >
            <option value="" disabled>
              Vehicle Brand
            </option>
            {vehicleBrands.map((vb) => (
              <option
                value={vb.vehicle_brand_id}
                selected={vb.vehicle_brand_id == vehicleBrand}
              >
                {vb.name}
              </option>
            ))}
          </select>
        </td>
        <td>
          <select
            className="form-control my-2"
            name="vehicleModel"
            id="vehicleModel"
            value={vehicleModel}
            disabled={vehicleModels.length == 0}
            onChange={(e) => setVehicleModel(e.target.value)}
          >
            <option value="a">Vehicle Model</option>
            {vehicleModels.map((vb) => (
              <option
                value={vb.vehicle_model_id}
                selected={vb.vehicle_model_id == vehicleModel}
              >
                {vb.name}
              </option>
            ))}
          </select>{" "}
        </td>
        <td>
          <input
            type="text"
            className="form-control"
            value={licensePlate}
            onChange={(e) => setLicensePlate(e.target.value)}
          />
        </td>
        <td>
          <button
            type="button"
            className="btn btn-success"
            onClick={() => {
              updateVehicle();
            }}
          >
            Update
          </button>
        </td>
      </tr>
    )) || (
      <tr>
        <td className="vehicleList_main">
          <div className="vl_text_div">
            <p className="vld_text">

              {vehicle.vehicle_brand}
            </p>

            <p className="vld_text">
              {vehicle.vehicle_model}
            </p>

            <p className="vld_text">
              {vehicle.vehicle_charger_type}
            </p>

            <p className="vld_text">
              {vehicle.license_plate}
            </p>
          </div>

          <div className="vl_btn_div">
            <button
              type="button"
              className="btn btn-danger "
              onClick={() => {
                deleteVehicle(vehicle.driver_vehicle_id);
              }}
            >
              Delete
            </button>
          </div>

        </td>
        {/* <td>{vehicle.vehicle_model}</td>
        <td>{vehicle.license_plate}</td>
        <td>
          <button
            type="button"
            className="btn btn-danger "
            onClick={() => {
              deleteVehicle(vehicle.driver_vehicle_id);
            }}
          >
            Delete
          </button>
        </td> */}
      </tr>
    )
  );
}
